var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD211(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_1472)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3106 14.0814C30.5558 12.8972 31.3321 11.2245 31.3321 9.37045C31.3321 5.7806 28.4219 2.87046 24.8321 2.87046C22.5864 2.87046 20.6067 4.00928 19.439 5.74091C19.9499 6.22406 20.4122 6.75795 20.8179 7.33452C21.561 5.8723 23.0796 4.87046 24.8321 4.87046C27.3174 4.87046 29.3321 6.88517 29.3321 9.37045C29.3321 10.4765 28.9331 11.4893 28.2711 12.2728C28.7087 12.8111 29.0619 13.4206 29.3106 14.0814Z",
    fill: "url(#paint0_linear_205_1472)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0864 28.8395C11.2412 28.9703 11.5021 29.001 11.6556 28.8271C11.7396 28.7318 11.8571 28.5188 11.9649 28.1497C12.0079 28.0025 12.0452 27.8452 12.0774 27.682C11.5893 27.8567 11.2114 28.065 11.0159 28.2867C10.8624 28.4606 10.9315 28.7087 11.0864 28.8395ZM12.2518 25.9898C13.1113 25.7882 13.8269 25.733 13.8269 25.733C13.8269 25.733 13.846 26.4316 13.7599 27.2822C13.6656 28.2141 13.445 29.3286 12.9344 29.9073C12.2924 30.6351 11.0562 30.6205 10.1732 29.8746C9.29025 29.1288 9.09495 27.9342 9.73698 27.2064C10.2972 26.5713 11.3532 26.2006 12.2518 25.9898Z",
    fill: "url(#paint1_linear_205_1472)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5244 19.9956L17.8259 20.5212L17.9702 21.4289L17.1336 21.2657L16.6433 22.0185L16.1586 21.262L15.3208 21.4189L15.472 20.5124L14.7775 19.9815L15.4759 19.4559L15.3316 18.5482L16.1682 18.7115L16.6586 17.9587L17.1432 18.7152L17.9811 18.5582L17.8299 19.4648L18.5244 19.9956ZM14.0675 23.5519L14.766 23.0263L14.0715 22.4955L14.2227 21.5889L13.3849 21.7459L12.9002 20.9894L12.4098 21.7422L11.5732 21.5789L11.7175 22.4866L11.0191 23.0122L11.7136 23.5431L11.5624 24.4496L12.4002 24.2927L12.8849 25.0492L13.3752 24.2964L14.2119 24.4596L14.0675 23.5519ZM17.8029 26.6109L18.5014 26.0853L17.8069 25.5544L17.9581 24.6479L17.1203 24.8048L16.6356 24.0483L16.1453 24.8011L15.3086 24.6379L15.453 25.5456L14.7545 26.0712L15.449 26.602L15.2978 27.5086L16.1356 27.3516L16.6203 28.1081L17.1107 27.3553L17.9473 27.5186L17.8029 26.6109ZM21.5613 23.5802L22.2598 23.0546L21.5653 22.5237L21.7165 21.6172L20.8787 21.7741L20.394 21.0176L19.9036 21.7704L19.067 21.6072L19.2114 22.5149L18.5129 23.0405L19.2074 23.5713L19.0562 24.4779L19.894 24.3209L20.3787 25.0774L20.8691 24.3246L21.7057 24.4879L21.5613 23.5802Z",
    fill: "url(#paint2_linear_205_1472)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 23.2848C4.91752 21.7538 2 17.699 2 12.9375C2 6.86237 6.74949 1.9375 12.6083 1.9375C17.469 1.9375 21.5661 5.32726 22.821 9.95137C22.9626 9.94217 23.1054 9.93751 23.2493 9.93751C26.9776 9.93751 30 13.0715 30 16.9375C30 20.5403 27.375 23.5075 24 23.8947V21.8745C26.2205 21.499 28 19.4861 28 16.9375C28 14.1071 25.8053 11.9375 23.2493 11.9375C22.5272 11.9375 21.8339 12.1107 21.2108 12.423C21.1791 11.8412 21.0937 11.2742 20.9599 10.7274L20.9569 10.7286C20.0091 6.78754 16.5839 3.9375 12.6083 3.9375C7.92179 3.9375 4 7.89796 4 12.9375C4 16.5991 6.0703 19.691 9 21.1081V23.2848Z",
    fill: "url(#paint3_linear_205_1472)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_1472",
    x1: 25.3855,
    y1: 2.87036,
    x2: 25.3855,
    y2: 14.0813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_205_1472",
    x1: 13.8269,
    y1: 25.733,
    x2: 10.2638,
    y2: 29.9512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95B6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_205_1472",
    x1: 16.6586,
    y1: 17.9587,
    x2: 16.6203,
    y2: 28.1081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95B6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_205_1472",
    x1: 16,
    y1: 1.9375,
    x2: 16,
    y2: 23.8947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E2F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_1472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD211);
export default __webpack_public_path__ + "static/media/d211.fab288949dd260ac2993f89cc2a043d5.svg";
export { ForwardRef as ReactComponent };